<template>
    <transition name="config">
        <div class="c-productspec__inner" v-show="baseLocaleLoaded">
            <template v-if="product.isConfigurable">
                <div class="c-form__floatinglabels">
                    <div class="form-group umbraco-forms-field shortanswer mandatory always-float">
                        <input
                            id="ralColor"
                            type="text"
                            name="ralColor"
                            v-model="ralColor"
                            :placeholder="$t('Product.RALkleur.Placeholder')"
                            v-mask="'####'"
                            class="form-control no-spinner"
                            pattern="[0-9]*"
                            :class="{ 'input-validation-error': $v.ralColor.$invalid }"
                        />
                        <label for="ralColor">{{ $t('Product.RALkleur') }}*</label>
                        <span class="field-validation-error" v-if="!$v.ralColor.required">{{ $t('Product.RALkleur') }} {{ $t('Product.RALkleur.Validatie.IsVerplicht') }}</span>
                        <span class="field-validation-error" v-else-if="!$v.ralColor.minLength">{{ $t('Product.RALkleur') }} {{ $t('Product.RALkleur.Validatie.AantalKarakters') }}</span>
                    </div>

                    <div class="form-group umbraco-forms-field dropdown dropdown mandatory alternating">
                        <select class="form-control" id="implementation" name="implementation" v-model="selectedImplementation" aria-required="true" aria-describedby="implementation">
                            <option v-for="implementation in product.implementations" :value="implementation" :key="implementation">{{ implementation }}</option>
                        </select>
                        <label for="implementation">{{ $t('Product.Uitvoering') }}*</label>
                    </div>
                    <div class="form-group umbraco-forms-field dropdown dropdown mandatory alternating">
                        <select class="form-control" id="options" name="options" v-model="selectedOption" aria-required="true" aria-describedby="options">
                            <option v-for="option in product.options" :value="option" :key="option">{{ option }}</option>
                        </select>
                        <label for="options">{{ $t('Product.Opties') }}*</label>
                    </div>
                </div>
            </template>

            <button type="button" @click="onclickAddToCart" class="btn btn-secondary btn-arrow" :disabled="submitStatus === 'PENDING'">
                <span>{{ $t('Product.Button.ProductToevoegen') }}</span
                ><i class="far fa-arrow-right"></i>
            </button>
            <a v-if="product.brochure != null" :href="product.brochure" target="_blank" class="btn btn-outline-secondary btn-arrow">
                <span>{{ $t('Product.Button.DownloadBrochure') }}</span
                ><i class="far fa-arrow-right"></i>
            </a>

            <transition name="modal">
                <div class="c-modal" v-if="modalOpen">
                    <div class="c-modal__backdrop"></div>
                    <div class="c-modal__frame">
                        <div class="c-modal__inner">
                            <div class="c-modal__inner--left">
                                <span class="h3">{{ $t('Offerte.Popup.Titel') }}</span>
                                <p>{{ $t('Offerte.Popup.Tekst') }}</p>
                            </div>
                            <div class="c-modal__inner--right">
                                <a :href="$t('Offerte.Popup.OfferteLink')" class="btn btn-secondary btn-arrow">
                                    <span>{{ $t('Offerte.Popup.OfferteAanvragen') }}</span
                                    ><i class="far fa-arrow-right"></i>
                                </a>
                                <div>
                                    {{ $t('Offerte.Popup.Of') }} <button type="button" class="closebtn" @click="closeModal">{{ $t('Offerte.Popup.Verder') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import Forms from '../forms/forms.module.js';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'product',
    props: {
        productId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            ralColor: '9010',
            selectedImplementation: null,
            selectedOption: null,
            modalOpen: false,
            submitStatus: null
        };
    },
    validations: {
        ralColor: {
            required,
            minLength: minLength(4)
        }
    },
    methods: {
        ...mapActions({
            getProductDetailsById: 'getProductById'
        }),
        ...mapMutations({
            addToCart: 'addToCart'
        }),
        itemAlreadyInCart(id) {
            getProductFromCartById;
        },
        closeModal() {
            this.modalOpen = false;
            this.submitStatus = 'OK';
        },
        onclickAddToCart() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            } else {
                this.submitStatus = 'PENDING';

                const payload = {
                    id: this.productId,
                    name: this.product.name,
                    description: this.product.description,
                    image: this.product.productImageSource,
                    productUrl: this.product.productUrl,
                    isConfigurable: this.product.isConfigurable,
                    ralColor: this.ralColor,
                    implementation: this.selectedImplementation,
                    option: this.selectedOption,
                    qty: 1
                };
                this.addToCart(payload);
                this.modalOpen = true;
            }
        }
    },
    created() {
        this.lang = JSON.parse(localStorage.getItem('language'));
        this.$i18n.set(this.lang);
        this.$store.dispatch('setLanguage', this.lang).then(function() {});
    },
    async mounted() {
        await this.getProductDetailsById(this.productId);
        setTimeout(() => {
            Forms();
        }, 250);
        this.selectedOption = this.product.options[0];
        this.selectedImplementation = this.product.implementations[0];
    },
    computed: {
        ...mapGetters({
            productDetails: 'productDetails',
            getProductFromCartById: 'getProductFromCartById'
        }),
        ...mapState({
            baseLocaleLoaded: state => state.baseLocaleLoaded
        }),
        product() {
            return this.productDetails;
        }
    }
};
</script>
